import { useContext, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { MatchPopoverBody } from './MatchPopoverBody';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const MatchPopover = ({
  children,
  disabled,
  speaker,
  speakerTrackId,
  matchIconId
}) => {
  const [selectedParticipant, setSelectedParticipant] = useState();
  const {
    setIsMatchingPopoverOpen,
    isMatchingPopoverOpen,
    selectedUtteranceId,
    firstUnmatchedUtteranceIdRef
  } = useContext(TranscriptContext);
  const {
    onMapSpeaker,
    onUnmapSpeaker
  } = useContext(TranscriptContext);
  const handleParticipantClick = clickedParticipant => {
    if (selectedParticipant && selectedParticipant.participantId === clickedParticipant.participantId) {
      setSelectedParticipant(undefined);
    } else {
      setSelectedParticipant(clickedParticipant);
    }
  };
  const handleMapClick = evt => {
    evt.stopPropagation();
    if (selectedParticipant) {
      onMapSpeaker(selectedParticipant.participantId, speakerTrackId);
    }
    setIsMatchingPopoverOpen(false);
    firstUnmatchedUtteranceIdRef.current = null;
  };
  const handleUnmapClick = () => {
    onUnmapSpeaker(speaker.participantId);
    setIsMatchingPopoverOpen(false);
    firstUnmatchedUtteranceIdRef.current = null;
  };
  const handleOnOpenChange = () => {
    firstUnmatchedUtteranceIdRef.current = null;
    setIsMatchingPopoverOpen(!isMatchingPopoverOpen);
  };
  const handlOnCloseComplete = () => {
    firstUnmatchedUtteranceIdRef.current = null;
    setSelectedParticipant(undefined);
  };
  const isPopoverOpen = isMatchingPopoverOpen && (matchIconId === firstUnmatchedUtteranceIdRef.current || matchIconId === selectedUtteranceId && firstUnmatchedUtteranceIdRef.current === null);
  const getPopoverContent = () => {
    return speaker.participantId !== '' ? {
      footer: /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "small",
        onClick: handleUnmapClick,
        "data-test-id": "matchPopover_unmatchButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.participantMatching.unmatchPopover.unmatch"
        })
      })
    } : {
      header: /*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.participantMatching.matchPopover.header"
        })
      }),
      body: /*#__PURE__*/_jsx(MatchPopoverBody, {
        onParticipantClick: handleParticipantClick,
        selectedParticipant: selectedParticipant,
        onMapClick: handleMapClick
      })
    };
  };
  if (disabled) {
    return children;
  }
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": "matchUnmatchPopover",
    open: isPopoverOpen,
    closeOnOutsideClick: true,
    closeOnTargetLeave: true,
    placement: "bottom",
    onCloseComplete: handlOnCloseComplete,
    onOpenChange: handleOnOpenChange,
    content: getPopoverContent(),
    children: children
  });
};